var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29289 9.29289C2.90237 9.68342 2.90237 10.3166 3.29289 10.7071L9.65685 17.0711C10.0474 17.4616 10.6805 17.4616 11.0711 17.0711C11.4616 16.6805 11.4616 16.0474 11.0711 15.6569L5.41421 10L11.0711 4.34315C11.4616 3.95262 11.4616 3.31946 11.0711 2.92893C10.6805 2.53841 10.0474 2.53841 9.65685 2.92893L3.29289 9.29289ZM18 9L4 9V11L18 11V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.29781390.svg";
export { ForwardRef as ReactComponent };